import { render, staticRenderFns } from "./huList.vue?vue&type=template&id=c77b3128"
import script from "./huList.vue?vue&type=script&lang=js"
export * from "./huList.vue?vue&type=script&lang=js"
import style0 from "./huList.vue?vue&type=style&index=0&id=c77b3128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports